// import React, { useState, useEffect } from "react";
// import Loginimg from "../../assets/images/Image.png";
// import { useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
// import { baseUrl } from "../../config/baseUrl";
// import logo from "../../assets/images/head-logo.png";

// export default function ForgetPassword() {
//   const navigate = useNavigate();
//   const token = localStorage.getItem("token");

//   const [email, setEmail] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [showPopup, setShowPopup] = useState(false);
//   const [message, setMessage] = useState("");
//   const [status, setStatus] = useState(false); // true = success

//   useEffect(() => {
//     localStorage.clear();
//     if (token) navigate("/");
//   }, []);

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!email) {
//       setMessage("Please enter your email address.");
//       setStatus(false);
//       setShowPopup(true);
//       return;
//     }

//     setLoading(true);

//     try {
//       const response = await fetch(`${baseUrl}/web/user/forgot-password`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ email }),
//       });

//       const data = await response.json();

//       setStatus(data.status);
//       setMessage(
//         data.status
//           ? "We've sent a password reset link to your email."
//           : data.message || "Something went wrong."
//       );
//     } catch (error) {
//       console.error("Forgot Password Error:", error);
//       setStatus(false);
//       setMessage("Server error. Please try again later.");
//     } finally {
//       setShowPopup(true);
//       setLoading(false);
//     }
//   };

//   const handleClosePopup = () => setShowPopup(false);

//   return (
//     <>
//       {loading && (
//         <div className="loader-main">
//           <div className="loader"></div>
//         </div>
//       )}

//       <section className="main-login">
//         <div className="container-fluid">
//           <div className="row">
//             <div
//               className="col-xl-6 b-center bg-size d-none d-lg-block"
//               style={{
//                 backgroundImage: `url(${Loginimg})`,
//                 backgroundSize: "cover",
//                 backgroundPosition: "center center",
//               }}
//             >
//               <div className="login-lft">
//                 <div className="login-lft-innr">
//                   <h3>Welcome</h3>
//                   <img className="img-logo" src={logo} alt="Logo" />
//                   <p className="text-white">
//                     Lorem ipsum dolor sit amet, consectetur adipisicing elit.
//                     Optio vel, laborum omnis atque quisquam ducimus...
//                   </p>
//                 </div>
//               </div>
//             </div>

//             <div className="col-xl-6 p-0">
//               <div className="login-card">
//                 <form onSubmit={handleSubmit} className="login-form">
//                   <h4>
//                     <span>Forgot Password</span>
//                   </h4>

//                   <div className="mb-4 frm-bx">
//                     <label className="form-label">Email</label>
//                     <input
//                       type="email"
//                       className="form-control"
//                       name="email"
//                       onChange={(e) => setEmail(e.target.value)}
//                       placeholder="Enter Your Email"
//                       value={email}
//                     />
//                     <span>
//                       <i className="fa fa-envelope-o" aria-hidden="true"></i>
//                     </span>
//                   </div>

//                   <div className="mb-4 mt-5 frm-bx">
//                     <button className="frm-btn w-100" type="submit" disabled={loading}>
//                       {loading ? (
//                         <>
//                           <span
//                             className="spinner-border spinner-border-sm me-2"
//                             role="status"
//                             aria-hidden="true"
//                           ></span>
//                           Sending...
//                         </>
//                       ) : (
//                         "Send Reset Link"
//                       )}
//                     </button>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//     </>
//   );
// }



import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast, Bounce } from "react-toastify";
import { baseUrl } from "../../config/baseUrl";
import Loginimg from "../../assets/images/Image.png";

export default function ForgetPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    localStorage.clear();
    if (localStorage.getItem("token")) {
      navigate("/");
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      toast.warn("Please enter your email");
      return;
    }

    try {
      setLoading(true);
      const { data } = await axios.post(`${baseUrl}/owner/auth/forgot-password`, { email });

      if (data.status) {
        toast.success("We’ve sent a password reset link to your email", {
          position: "top-right",
          autoClose: 3000,
          theme: "light",
          transition: Bounce,
        });
        navigate("/login");
      } else {
        toast.error(data.message || "Something went wrong");
      }
    } catch (error) {
      toast.error("Server error. Please try again later.");
      console.error("Forgot password error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <section className="main-login">
        <div className="container-fluid">
          <div className="row">
            <div
              className="col-xl-6 b-center bg-size d-none d-lg-block d-xl-block"
              style={{
                backgroundImage: `url(${Loginimg})`,
                backgroundSize: "cover",
                backgroundPosition: "center center",
                display: "block",
              }}
            >
              <div className="login-lft">
                <img className="" src="/pidigihub.jpg" alt="JewelDesk" />
              </div>
            </div>
            <div className="col-xl-6 p-0">
              <div className="login-card">
                <form onSubmit={handleSubmit} className="login-form">
                  <h4>
                    <span>Forgot Password</span>
                  </h4>

                  <div className="mb-4 frm-bx">
                    <label className="form-label">Email</label>
                    <input
                      type="email"
                      className="form-control"
                      name="email"
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="Enter your registered email"
                      value={email}
                    />
                    <span><i className="fa fa-envelope-o" aria-hidden="true" /></span>
                  </div>

                  <div className="mb-4 mt-5 frm-bx">
                    <button className="frm-btn w-100" type="submit" disabled={loading}>
                      {loading ? "Sending..." : "Send Reset Link"}
                    </button>
                  </div>

                  <div className="mb-4 frm-bx">
                    <Link to="/login" className="btn btn-primary w-100">
                      Back to Login
                    </Link>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
